import { MusicEntity } from '~/features/dashboard/store/models';

export const fakeMusic: MusicEntity = {
    id: '',
    dealId: ``,
    connectedDeals: [],
    meta: {
        artist: '',
        artistImage: '',
        releaseDate: '',
        title: '',
        featArtists: [],
        description: {
            title: '',
            text: '',
        },
    },
    roles: [],
    writingSharePercent: '',
    label: '',
    dealDeliveredTo: '',
    ISRC: '',
    UPC: '',
    dates: [],
    audits: [],
    assets: [],
    gSongReleaseYear: '',
    releaseDate: '',
    keyDates: [],
    gSongFeatArtist1: '',
    gSongFeatArtist2: '',
    gSongFeatArtist3: '',
    gSongFirstDeal: '',
    songProjectTrack: [],
    neighbouringRights: '',
    otherEligible: '',
    publishing: '',
    masters: '',
    writerShareEligible: '',
    gMyWriterName: '',
    gPublisherName: '',
    writingShare: 0,
    publishingShare: 0,
};
